import React, { useState } from 'react';
import { Button, Card, Collapse, Form } from 'react-bootstrap';

import { FormRow210 } from '../../../app/components/FormRow';
import momencik from '../../../common/momencik';
import CompanyByNameOrNipSelector from '../Company/CompanyByNameOrNipSelector';

interface AddExamToInvoiceFiltersProps {
  companyId?: string;
  dateFrom?: string;
  dateTo?: string;
  withoutInvoiceAndReceipt: boolean;
  completed: boolean;
  totalCount: number;
  onCompanyChange: (companyId?: string) => void;
  onDateFromChange: (date?: string) => void;
  onDateToChange: (date?: string) => void;
  onWithoutInvoiceAndReceiptChange: (value: boolean) => void;
  onCompletedChange: (value: boolean) => void;
  onSelectAll: () => void;
  onClear: () => void;
}

export const AddExamToInvoiceFilters: React.FC<
  AddExamToInvoiceFiltersProps
> = ({
  companyId,
  dateFrom,
  dateTo,
  withoutInvoiceAndReceipt,
  completed,
  totalCount,
  onCompanyChange,
  onDateFromChange,
  onDateToChange,
  onWithoutInvoiceAndReceiptChange,
  onCompletedChange,
  onSelectAll,
  onClear,
}) => {
  const [open, setOpen] = useState(true);

  return (
    <Card className="mb-3">
      <Card.Header
        className="d-flex align-items-center justify-content-between py-2 px-4"
        style={{ cursor: 'pointer' }}
        onClick={() => setOpen(o => !o)}
      >
        <span>Filtry</span>
        <span>{open ? '▲' : '▼'}</span>
      </Card.Header>
      <Collapse in={open}>
        <div>
          <Card.Body className="py-3 px-4">
            <Form>
              <FormRow210 controlId="company" label="Firma" className="mb-2">
                <CompanyByNameOrNipSelector
                  value={companyId}
                  clearable={true}
                  onChange={option =>
                    onCompanyChange(option?.value as string | undefined)
                  }
                  placeholder="Wszystkie firmy"
                />
              </FormRow210>
              <FormRow210
                controlId="dateFrom"
                label="Data końca badania od"
                className="mb-2"
              >
                <Form.Control
                  type="date"
                  name="datepic"
                  placeholder="DateRange"
                  value={momencik(
                    dateFrom ? new Date(dateFrom) : undefined,
                    'YYYY-MM-DD',
                  )}
                  onChange={e => onDateFromChange(e.target.value || undefined)}
                />
              </FormRow210>
              <FormRow210
                controlId="dateTo"
                label="Data końca badania do"
                className="mb-2"
              >
                <Form.Control
                  type="date"
                  name="datepic"
                  placeholder="DateRange"
                  value={momencik(
                    dateTo ? new Date(dateTo) : undefined,
                    'YYYY-MM-DD',
                  )}
                  onChange={e => onDateToChange(e.target.value || undefined)}
                />
              </FormRow210>
              <div className="d-flex align-items-center justify-content-between mt-2">
                <div className="d-flex gap-4">
                  <Form.Check
                    type="checkbox"
                    label="Bez faktury i paragonu"
                    checked={withoutInvoiceAndReceipt}
                    onChange={e =>
                      onWithoutInvoiceAndReceiptChange(e.target.checked)
                    }
                  />
                  <Form.Check
                    type="checkbox"
                    label="Zakończone"
                    checked={completed}
                    onChange={e => onCompletedChange(e.target.checked)}
                  />
                </div>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={e => {
                    e.stopPropagation();
                    onClear();
                  }}
                >
                  Wyczyść filtr
                </Button>
              </div>
            </Form>
          </Card.Body>
        </div>
      </Collapse>
      <Card.Body className="py-2 px-4">
        <div className="d-flex align-items-center justify-content-between">
          <span>
            Znaleziono <strong>{totalCount}</strong> badań spełniających
            kryteria
          </span>
          <Button variant="outline-primary" onClick={onSelectAll}>
            Zaznacz wszystkie spełniające kryteria
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};
